import axios from "axios"
import { MOD_MOVEMENT } from "redux/reducers/gasMovements/gasMovementsReducer"
import { ADD_MOVEMENT_MODE } from "redux/reducers/gasMovements/gasMovementsReducer"
import { DELETE_MOVEMENT_MODE } from "redux/reducers/gasMovements/gasMovementsReducer"
import { EDIT_MOVEMENT_MODE } from "redux/reducers/gasMovements/gasMovementsReducer"
import { MOVEMENT_SELECTED } from "redux/reducers/gasMovements/gasMovementsReducer"
import { CREATE_MOVEMENT } from "redux/reducers/gasMovements/gasMovementsReducer"
//import { DELETE_MOVEMENT } from "redux/reducers/gasMovements/gasMovementsReducer"
import { GET_MOVEMENTS } from "redux/reducers/gasMovements/gasMovementsReducer"
import { RESET_MOVEMENT_SELECTED } from "redux/reducers/gasMovements/gasMovementsReducer"
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";
import { api_get } from "services/api"

export const getMovements = (token) => {
  const url = `${process.env.REACT_APP_URL}/crm/gas-movements`
  const headers = { headers: { Authorization: token } }
  let payload = {}
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await api_get(url).then(resp => {
      payload = {
        type: GET_MOVEMENTS,
        payload: resp
      }
      dispatch(payload)
    }).catch(err => {
      // const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const movementSelected = (id) => {
  return {
    type: MOVEMENT_SELECTED,
    payload: id
  }
}

export const addMovementMode = () => {
  return {
    type: ADD_MOVEMENT_MODE,
  }
}

export const editMovementMode = () => {
  return {
    type: EDIT_MOVEMENT_MODE,
  }
}

export const deleteMovementMode = () => {
  return {
    type: DELETE_MOVEMENT_MODE,
  }
}

export const resetMovementSelected = () => {
  return {
    type: RESET_MOVEMENT_SELECTED
  }
}
export const createNewMovement = (form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/gas-movements`
  const headers = { Authorization: token }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.post(url, form, {headers}).then(resp => {
      payload = {
        type: CREATE_MOVEMENT,
        payload: resp.data
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El movimiento se a creado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const editMovement = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/gas-movements/${id}`
  const headers = { Authorization: token } 
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.put(url, form, {headers}).then(resp => {
      payload = {
        type: MOD_MOVEMENT,
        payload: resp.data
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El movimiento se a editado con éxito', color: 'success' }
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

//Por ahora no se necesita esta función
// export const deleteMovement = (id, token) => {
//   const url = `${process.env.REACT_APP_URL}/crm/gas-movements/${id}`
//   const headers = { headers: {Authorization: token } }
//   let payload = {}
//   return async ( dispatch ) => {
//     dispatch({ type: START_REQUEST_SEARCH })

//     await axios.delete(url, headers).then(resp => {
//       payload = {
//         type: DELETE_MOVEMENT,
//         payload: resp.data.id
//       }
//       dispatch(payload)
//       dispatch({
//          type: SET_SNACKBAR_SEARCH,
//          payload: { message: 'El movimiento se a eliminado con éxito', color: 'success' }
//       })
//     }).catch(error => {
//       const err = error.response.data?.message.error
//       dispatch({
//         type: SET_SNACKBAR_SEARCH,
//         payload: {
//           message: err ? err : "Error contacte al administrador",
//           color: 'danger'
//          }
//       })
//     })
//     dispatch({ type: STOP_REQUEST_SEARCH })
//   }
// }